import m from 'moment';
export const moment = m;
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const dateFormat = 'YYYY-MM-DD';
export const get_current_datetime = (onlydate = false): string => {
  if (onlydate) {
    return moment(new Date()).format(dateFormat);
  } else {
    return moment(new Date()).format(dateTimeFormat);
  }
};

export const formatDateTime = (
  dateTime: string,
  format: string = dateTimeFormat
): string => {
  return moment(new Date(dateTime)).format(format);
};
export const formatDate = (
  dateTime: string,
  format: string = dateFormat
): string => {
  return moment(new Date(dateTime)).format(format);
};
export default moment;
